import sessionStore from "../../../store/session";

export const setAccessToken = (request: Request): void => {
  const accessToken = sessionStore.accessToken;
  if (accessToken) {
    request.headers.set("x-access-token", accessToken);
  }
};
